import React, {useState} from 'react'
import './WalletProfileEdit.scss'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";

import {Zoom} from "react-reveal";
import {connect} from "react-redux";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import CheckUserNameQuery from "../../queries/CheckUserNameQuery";
import cogoToast from "cogo-toast";
import {api, assetUrl} from "../../serviceApi";
import axios from "axios"

const dummyImage = assetUrl+'images/default_profileUpload_image.svg'
const arrow = assetUrl+'images/white-arrow-right.png'
const check = assetUrl+"images/username_check.svg";


const WalletProfileEdit = (props) => {
	const [username, setUsername] = useState("");
	const [usernameSuggestion, setUsernameSuggestion] = useState([]);
	const [available, setAvailable] = useState(false);
	const [Loading, setLoading] = useState(false);
	const [file, setFile] = useState(null)

	const getUserNameSuggestion = (e) => {
		setUsername(e.target.value)
		let variables = {
			username: username === e.target.value ? username : e.target.value,
			mobileNumber: "+91" + props.user_details.mobileNumber
		}
		fetchQuery(environment, CheckUserNameQuery, variables)
			.toPromise()
			.then(response => {
				if (response.checkUsername !== null && response.checkUsername.length > 1) {
					setAvailable(false)
					setUsernameSuggestion(response.checkUsername)

				} else {
					if (e.target.value === "") {
						setAvailable(false)
						setUsernameSuggestion([])
					} else {
						setAvailable(true)
						setUsernameSuggestion([])
					}

				}
			}, err => {
				console.log(err);
				setAvailable(false)
				setUsernameSuggestion([])
			});
	}
	const handleInpuChange = (e) => {
		setUsername(e.target.value)
		if (e.target.value === "") {
			setAvailable(false)
		}
		getUserNameSuggestion(e)

	}
	const onUsernameSelect = (username) => {
		setUsername(username)
		let variables = {
			username: username,
			mobileNumber: "+91" + props.user_details.mobileNumber
		}
		fetchQuery(environment, CheckUserNameQuery, variables)
			.toPromise()
			.then(response => {
				if (response.checkUsername !== null && response.checkUsername.length > 1) {
					setUsername(username)
					setAvailable(false)
					setUsernameSuggestion(response.checkUsername)

				} else {
					setUsername(username)
					setAvailable(true)
					setUsernameSuggestion([])
				}
			}, err => {
				console.log(err);
				setUsername(username)
				setAvailable(true)
				setUsernameSuggestion([])

			});

	}
	let formData = new FormData();
	let ImageFile

	const _handleImage = (e) => {
		e.preventDefault()
		let reader = new FileReader();
		let fileLocal = e.target.files[0];
		if (fileLocal && fileLocal.type.match('image.*')) {
			reader.readAsDataURL(fileLocal);

		} else {
			console.log("error")
		}
		reader.onloadend = () => {

			setFile(fileLocal)
		}
		ImageFile = fileLocal

	}

	const handleSubmit = () => {
		ImageFile = file
		setLoading(true)
		formData.append("query", `mutation upload{
		updateProfile(username:"${username}"){message user{ username
      shortUsername
      avatar}}}`)
		formData.append('profile_pic', ImageFile)
		let token = localStorage.getItem("token")
		let config;
		if (token !== null && token !== undefined && token !== "") {
			config = {
				headers: {
					'Accept': 'application/json',
					'Authorization': 'JWT ' + token,
					'content-Type': "application/json"
				}
			};
		} else {
			config = {
				headers: {
					'Accept': 'application/json'
				}
			};
		}
		// console.log(formData)

		axios.post(api, formData, config).then((response) => {
			// console.log(response)

			if (response) {
				setLoading(false)
			}

			if (response !== null || response !== "" || response !== undefined) {
				if (response.data.data.updateProfile !== null) {
					cogoToast.success('Updated successfully')
					setTimeout(()=>{
						props.history.goBack()
					},1000)

				} else if (response.data.errors !== null) {

					cogoToast.error(`something went wrong, ${response.data.errors[0].message}`)
				}
			}
		})

	}

	return (
		<div className={'wallet-profile-edit-component-main'}>
			<TopNavSubpage heading={"My Profile"} wallet={false} notify={true}/>
			<div className={'d-flex flex-column justify-content-between main-content'} >
				<div className={"wallet-profile-edit-component p-4"}>
					<div className={"text-center"}>
						<div className={"main-image"} style={props.wallet_data.user.avatar === null?{opacity:.5}:{opacity:1}}>
							{
								props.wallet_data.user.avatar === null ?
									<p className={"main-image-avatar mb-0"}>{props.wallet_data.shortUsername && (props.wallet_data.shortUsername).toUpperCase()}</p>
									:
									<img src={`${props.wallet_data.user.avatar}`} alt={"alt"} className={'main-image'}/>
							}

						</div>
						<div className={"upload-wrap mb-2"}>
							<p className={'upload-text'}>{file !== null ? file.name : "Upload a profile Photo"}</p>
							<input id={"upload"} type={"file"} onChange={(e) => _handleImage(e)}
							       placeholder={"Upload a profile Photo"}/>
						</div>

					</div>

					<div className={'form-section'}>
						<div className={"field-wrap"}>
							<p className={"label"}>Username</p>
							<input className={"input-field"} placeholder={props.wallet_data.user.username}
							       value={username}
							       onInput={(e) => handleInpuChange(e)}
							       onChange={(e) => handleInpuChange(e)}/>

							{
								available &&
								<div className={'d-flex justify-content-between align-items-center mt-2'}>

									<p className={"username-check-text my-0"}>Username available</p>
									<img src={check} alt={"alt"} className={"username-check"}/>
								</div>
							}
							{

								usernameSuggestion.length > 1 &&
								<div className={'username-suggest-box p-3'}>
									<p className={"username-suggest-title"}>Username Suggestion</p>
									{(usernameSuggestion).slice(0, 3).map(item => {
										return <p className={"username-suggest"}
										          onClick={() => onUsernameSelect(item.username)}>
											{item.username}</p>

									})}
								</div>
							}
						</div>
						{/*<div className={"field-wrap"}>*/}
						{/*    <p className={"label"}>State</p>*/}
						{/*    /!*<input className={"input-field"} placeholder={"@xyz"}/>*!/*/}
						{/*    <select className={"input-field"} >*/}
						{/*	    <option>Select Your State</option>*/}
						{/*	    <option>Tamil Nadu</option>*/}
						{/*	    <option>Kerala</option>*/}
						{/*	    <option>Andhra Pradesh</option>*/}
						{/*	    <option>Karnataka</option>*/}
						{/*    </select>*/}
						{/*</div>*/}

					</div>
				</div>
				<div className={"buttonWrapper"}>
					<button className={"submit-button d-flex justify-content-center align-items-center"}
					        disabled={Loading}
					        onClick={handleSubmit}
					>
						<p className={"mb-0"}>Update Changes</p>
						<img src={arrow} alt={"alt"} className={''} style={{marginLeft: "14px"}}/>
					</button>
				</div>
			</div>

		</div>
	)
}
const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	wallet_data: state.WalletReducer.wallet_data
});

export default connect(mapStateToProps)(WalletProfileEdit)
